// extracted by mini-css-extract-plugin
export default {"section":"show-token_section__wjDGn","container":"show-token_container__1MAKM"};